import * as angular from "angular";
import {IController} from "angular";

export class preferencesSliderCtrl implements IController {

  sliderValue: number;
  onChange: Function;
  onChangePercentage: Function;

  private valueInPercentage: number;

  /* @ngInject */
  constructor() {}

  $onInit() {
    this.valueInPercentage = this.sliderValue * 100;
  }

  $onChanges(changes) {
    if (changes.sliderValue && !changes.sliderValue.isFirstChange()) {
      this.$onInit()
    }
  };
}

angular
  .module('bringoz.admin.site-preferences')
  .component('preferencesSlider', {
    bindings: {
      sliderValue: '<',
      onChangePercentage: '&'
    },
    template: require('./preferences-slider.html').default,
    controller: preferencesSliderCtrl
  });
